import React from 'react'
import ELearningCourseEnroll from '../../../modules/ELearning/Course/Enroll'

const ELearningCourseEnrollPage = () => {
  return <ELearningCourseEnroll />
}

export default ELearningCourseEnrollPage
